import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from '@/components/ui/carousel';
import { cn } from '@/lib/utils';
import { FC } from 'react';
import authCotton from '@/assets/img/auth-cotton.png';
import authGrain from '@/assets/img/auth-grain.png';
import authRobot from '@/assets/img/auth-robot.png';
import Autoplay from 'embla-carousel-autoplay';
import { useTranslation } from 'react-i18next';

export const AuthCarousel: FC = () => {
  const { t } = useTranslation();
  const carouselImages = [
    { img: authRobot },
    { img: authGrain },
    { img: authCotton },
  ];
  return (
    <Carousel
      opts={{
        align: 'start',
        loop: true,
      }}
      plugins={[
        Autoplay({
          delay: 2000,
        }),
      ]}
      className="w-full h-full"
    >
      <CarouselContent>
        {carouselImages.map((item, index) => (
          <CarouselItem key={index}>
            <div className="relative inset-0 h-[calc(100vh-120px)] w-full flex flex-col items-center justify-end p-12">
              <img
                src={item.img}
                alt={`Auth slide ${index + 1}`}
                className="object-cover absolute inset-0 w-full h-full -z-10"
              />
              <div className="absolute top-0 left-0 bottom-0 right-0 bg-black opacity-30 z-[-1]"></div>
              <div
                className={cn(
                  'w-full flex flex-col items-center justify-center space-y-5 px-[50px]',
                )}
              >
                <h2
                  className={cn('text-white text-xl font-semibold text-center')}
                >
                  {t('government.crop.monitoring.system')}
                </h2>
                <p className={cn('text-white/70 text-center text-sm')}>
                  {t('electron.document.exchange.description')}
                </p>
              </div>
            </div>
          </CarouselItem>
        ))}
      </CarouselContent>
    </Carousel>
  );
};
